import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Profile from "./component/Profile";
import "remixicon/fonts/remixicon.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/style.css";
import LoginScreen from "./Screens/LoginScreen";
import SignupScreen from "./Screens/SignupScreen";
import ForgotPasswordScreen from "./Screens/ForgotPasswordScreen";
import OtpScreen from "./Screens/OtpScreen";
import Billing from "./component/Billing";
import PaymentInquiry from "./component/PaymentInquiry";
import Notification from "./component/Notification";
import ConfirmPasswordScreen from "./Screens/ConfirmPasswordScreen";
import NewChecklistScreen from "./Screens/NewChecklistScreen";
import CheckListScreen from "./Screens/CheckListScreen";
import UserManagementScreen from "./Screens/UserManagementScreen";
import HomeScreen from "./Screens/HomeScreen";
import { getCookie } from "./utils/Common";
import TemplateScreen from "./Screens/TemplateScreen";
import BiilingScreen from "./Screens/BiilingScreen";
import PaymentInquirieScreen from "./Screens/PaymentInquirieScreen";
import GoogleSignupScreen from "./Screens/GoogleSignupScreen";
import PrivacyPolicy from "./Screens/PrivacyPolicy";
import SubmittedChecklistScreen from "./Screens/SubmittedChecklistScreen";
import Terms from "./component/Terms";
import ChatScreen from "./Screens/ChatScreen";
import AiAnalysisScreen from "./Screens/AiAnalysisScreen";
import FindingScreen from "./Screens/FindingScreen";
import CapaListScreen from "./Screens/CapaListScreen";
import CapaDetailScreen from "./Screens/CapaDetailScreen";
import AuditScreen from "./Screens/AuditScreen";
import SitesScreen from "./Screens/SitesScreen";
import AcesCatalogueScreen from "./Screens/AcesCatalogueScreen";
import AiAnalysesScreen from "./Screens/AiAnalysesScreen";
import FindingsRegisterScreen from "./Screens/FindingsRegisterScreen";
import AiSettingsScreen from "./Screens/AiSettingsScreen";
import { refreshPermissions } from "./utils/permissions";

function App() {
const cookie: any = getCookie("data");
const [token] = useState<string | null>(cookie?.token || null);

  // Sessions from before QualiCheck AI carry no permissions; fetch them once.
  useEffect(() => {
    if (token && cookie?.role !== "SUPER_ADMIN" && !cookie?.permissions) refreshPermissions();
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps


  const PrivateRoute = ({ element }: { element: any }) => {
    return token ? element : <Navigate to="/login" replace />;
  };

  const PublicRoute = ({ element }: { element: any }) => {
    return token ? <Navigate to="/home" replace /> : element;
  };
  return (
    <Routes>
      {/* Redirect root to login or home based on auth */}
      <Route
        path="/"
        element={
          token ? (
            <Navigate to="/home" replace />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />

      {/* Public (unauthenticated) routes */}
      <Route
        path="/login"
        element={<PublicRoute element={<LoginScreen />} />}
      />
      <Route
        path="/signup"
        element={<PublicRoute element={<SignupScreen />} />}
      />
      <Route
        path="/googlesignup"
        element={<PublicRoute element={<GoogleSignupScreen />} />}
      />
      <Route
        path="/forgotpassword"
        element={<PublicRoute element={<ForgotPasswordScreen />} />}
      />
      <Route path="/otp" element={<PublicRoute element={<OtpScreen />} />} />
      <Route
        path="/confirmpassword"
        element={<PublicRoute element={<ConfirmPasswordScreen />} />}
      />

      {/* Private (authenticated) routes */}
      <Route path="/home" element={<PrivateRoute element={<HomeScreen />} />} />

      <Route
        path="/billing"
        element={<PrivateRoute element={<BiilingScreen />} />}
      />
      <Route
        path="/usermanagment"
        element={<PrivateRoute element={<UserManagementScreen />} />}
      />
       <Route
        path="/submittedChecklist"
        element={<PrivateRoute element={<SubmittedChecklistScreen />} />}
      />
      <Route
        path="/checklist"
        element={
          <PrivateRoute element={<CheckListScreen isTemplate={false} />} />
        }
      />
      <Route
        path="/templatelist"
        element={
          <PrivateRoute element={<CheckListScreen isTemplate={true} />} />
        }
      />
      <Route
        path="/paymentinquiry"
        element={<PrivateRoute element={<PaymentInquirieScreen />} />}
      />
      <Route path="/profile" element={<PrivateRoute element={<Profile />} />} />
      <Route
        path="/newchecklist"
        element={<PrivateRoute element={<NewChecklistScreen />} />}
      />
      <Route
        path="/notification"
        element={<PrivateRoute element={<Notification />} />}
      />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<Terms/>} />
       <Route
        path="/chat"
        element={<PrivateRoute element={<ChatScreen />} />}
      />
      <Route path="/ai/analyses" element={<PrivateRoute element={<AiAnalysesScreen />} />} />
      <Route path="/ai/findings" element={<PrivateRoute element={<FindingsRegisterScreen />} />} />
      <Route path="/ai/analysis/:id" element={<PrivateRoute element={<AiAnalysisScreen />} />} />
      <Route path="/ai/finding/:id" element={<PrivateRoute element={<FindingScreen />} />} />
      <Route path="/capa" element={<PrivateRoute element={<CapaListScreen />} />} />
      <Route path="/capa/:id" element={<PrivateRoute element={<CapaDetailScreen />} />} />
      <Route path="/audit" element={<PrivateRoute element={<AuditScreen />} />} />
      <Route path="/settings/sites" element={<PrivateRoute element={<SitesScreen />} />} />
      <Route path="/admin/standards" element={<PrivateRoute element={<AcesCatalogueScreen />} />} />
      <Route path="/admin/aces" element={<Navigate to="/admin/standards" replace />} />
      <Route path="/admin/ai-settings" element={<PrivateRoute element={<AiSettingsScreen />} />} />
      
    </Routes>
  );
}

export default App;
